module.exports = __webpack_public_path__ + "static/media/virtual-logo.df2d9947.png";